import React, { useMemo, useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

import FeatureTour from 'pages/FeatureTour'
import Footer from 'components/Footer'
import ImpersonationBanner from 'components/ImpersonationBanner'
import PremiumWidget from 'components/PremiumWidget'
import ProductionBanner from 'components/ProductionBanner'
import ServerErrorBanner from 'components/ServerErrorBanner'
import SideNavbar from 'components/SideNavbar'
import SiteMessageBanners from 'pages/SiteMessageBanners'
import UpgradeModal from 'pages/shared/UpgradeModal'

import { useFeaturesContext } from 'hooks/FeaturesContext'
import { usePremiumFeaturesContext } from 'hooks/PremiumFeaturesContext'
import useScreenSize from 'hooks/useScreenSize'
import { useSessionContext } from 'hooks/SessionContext'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

const AppLayout = () => {
  const { session, isSessionLoaded, isUpgraded } = useSessionContext()
  const { isEnabledFeaturesLoaded } = useFeaturesContext()
  const { arePremiumFeaturesLoaded } = usePremiumFeaturesContext()
  const [showUpgradeModal, setShowUpgradeModal] = useState(isUpgraded)

  const screenSize = useScreenSize()

  useEffect(() => {
    if (!isSessionLoaded) { return }

    setShowUpgradeModal(isUpgraded)
  }, [isUpgraded, isSessionLoaded])

  const { isDealerAdmin } = useMemo(() => session || {}, [session])

  if (!isEnabledFeaturesLoaded || !isSessionLoaded || !arePremiumFeaturesLoaded) { return null }

  return (
    <S.Layout>
      {showUpgradeModal && !session.isDealerAdmin && (<UpgradeModal closeCallback={() => setShowUpgradeModal(false)} />)}
      <SideNavbar />

      <S.BannersAndMain>
        <ProductionBanner />
        <ServerErrorBanner />
        <SiteMessageBanners />
        <FeatureTour />
        <ImpersonationBanner />
        {isDealerAdmin && screenSize !== 'small' && <PremiumWidget />}

        <S.MainContent>
          <Outlet />
        </S.MainContent>

        <Footer />
      </S.BannersAndMain>
    </S.Layout>
  )
}

export default AppLayout

const S = {
  Layout: styled.div`
      display: flex;
      height: 100%;
    `,
  BannersAndMain: styled.div`
      display: flex;
      flex: 1 1 auto;
      width: 100%;
      flex-direction: column;
      background-color: ${color('background')};
  
      @media ${screenSize.small} {
        margin: 60px 0px 0px 0px; /* Appbar height */
      }
    `,
  MainContent: styled.div`
      flex: 1;
      width: 100%;
    `
}
